/* eslint-disable @typescript-eslint/no-unused-vars */
import type { FieldContext } from 'vee-validate';

type InteractionEventGetter = (ctx: Partial<FieldContext>) => string[];
export type InteractionMode = 'passive' | 'lazy' | 'aggressive' | 'eager';

// Validates on submit only
const passive = () => [];

const lazy: InteractionEventGetter = ({ meta, errorMessage }) => {
  return ['change'];
};

const aggressive: InteractionEventGetter = () => ['input'];

const eager: InteractionEventGetter = ({ meta, errorMessage }) => {
  if (errorMessage?.value) {
    return ['input'];
  }

  return ['change'];
};

export const modes = {
  passive,
  lazy,
  aggressive,
  eager,
};
